var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 63,
    viewBox: "0 0 147 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.894 27.9804C85.014 24.5204 81.234 21.1604 77.354 17.7004C82.934 13.2604 87.424 7.7504 94.064 4.3104C115.814 -6.9796 143.464 5.1404 146.694 27.4104C149.194 44.6904 135.614 60.5804 116.354 62.7104C105.014 63.9604 95.094 60.9604 86.954 53.7804C74.064 42.4004 61.364 30.8504 48.484 19.4704C43.094 14.7004 36.474 13.3504 29.314 15.4504C22.104 17.5704 17.734 22.2104 16.514 28.9404C15.184 36.2604 19.334 43.3104 26.684 46.6404C33.944 49.9304 42.674 48.6804 48.584 43.4904C51.354 41.0504 54.094 38.5904 56.834 36.1104C57.254 35.7304 57.554 35.2604 57.854 34.9004C61.914 38.5104 65.714 41.8904 69.644 45.3904C65.384 49.0304 61.364 52.9904 56.754 56.3004C36.464 70.8804 5.25402 60.3404 0.604021 37.4604C-2.91598 20.1004 9.27402 3.9104 28.694 0.620403C40.794 -1.4296 51.424 1.6304 60.184 9.3604C72.864 20.5504 85.394 31.8804 98.004 43.1304C104.274 48.7304 112.894 50.0204 120.484 46.5604C128.374 42.9604 132.464 34.6804 130.094 27.0904C127.684 19.3404 119.664 14.1704 110.804 14.6104C105.924 14.8504 101.794 16.5404 98.344 19.5804C95.184 22.3604 92.054 25.1704 88.894 27.9904V27.9804Z",
    fill: "#474EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.9cbe186011d4ee763cad4a05cc31ba20.svg";
export { ForwardRef as ReactComponent };